module.exports = __webpack_public_path__ + "static/media/arrowButton.a72d3e6b.svg";